import React, { useState } from "react";
import { AlertTriangle, ChevronDown } from "lucide-react";

import { dataHora, reais } from "../comum/formato";

const EXPLICACAO = {
  frete_cobrado: "O cliente usou cupom de frete grátis, mas o pedido cobrou a taxa de entrega. Corrigido na versão 1.5.718.",
  desconto_perdido: "O cupom foi aceito, mas o desconto não ficou no total (acontecia ao editar o pedido na tela Delivery). Corrigido na versão 1.5.718.",
  divergente: "O desconto anotado no uso do cupom é diferente do que o total do pedido mostra.",
};

export default function Alertas({ alertas }) {
  const [aberto, setAberto] = useState(null);
  if (!alertas?.length) return null;
  return (
    <section className="rounded-xl border border-amber-500/40 bg-amber-500/5 p-4 sm:p-5 space-y-2" data-e2e="alertas-cupons">
      <h3 className="font-semibold flex items-center gap-2"><AlertTriangle className="w-4 h-4 text-amber-500" /> Pedidos em que o cupom não foi aplicado como deveria</h3>
      {alertas.map((a) => (
        <div key={a.tipo} className="rounded-lg border bg-card">
          <button type="button" onClick={() => setAberto(aberto === a.tipo ? null : a.tipo)} className="w-full flex items-center gap-3 p-3 text-left">
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold">{a.titulo}</p>
              <p className="text-xs text-muted-foreground">{EXPLICACAO[a.tipo]}</p>
            </div>
            <span className="text-right shrink-0">
              <span className="block text-sm font-bold tabular-nums">{a.quantidade} pedido{a.quantidade === 1 ? "" : "s"}</span>
              <span className="block text-xs text-muted-foreground tabular-nums">{reais(a.valor)}</span>
            </span>
            <ChevronDown className={`w-4 h-4 shrink-0 transition-transform ${aberto === a.tipo ? "rotate-180" : ""}`} />
          </button>
          {aberto === a.tipo && (
            <ul className="border-t divide-y text-xs max-h-64 overflow-y-auto">
              {a.pedidos.map((p) => (
                <li key={p.id} className="flex items-center gap-3 px-3 py-2 tabular-nums">
                  <span className="font-semibold w-16">{p.codigo}</span>
                  <span className="text-muted-foreground w-28">{dataHora(p.criado_em)}</span>
                  <span className="flex-1 truncate">{p.cliente || "—"} · {p.cupom}</span>
                  <span className="font-semibold">{reais(p.valor)}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </section>
  );
}
